import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Y si ya tengo experiencia?',
  a: 'Mejor todavía. Este sistema NO fue creado para enseñarte peluquería desde cero. Fue creado para ayudarte a trabajar con más estructura profesional. Muchas veces las profesionales con experiencia son justamente quienes más valor encuentran, porque detectan rápidamente cuántas situaciones siguen resolviendo improvisando.'
}, {
  q: '¿Esto sirve si trabajo sola?',
  a: 'Sí. De hecho, probablemente sea uno de los perfiles que más valor obtiene. Porque cuando trabajás sola, casi toda la operación depende de vos: consultas, organización, agenda, cobros, seguimiento, manejo de clientas. Y justamente este sistema fue pensado para ayudarte a estructurar mejor ese día a día.'
}, {
  q: '¿Funciona si recién estoy empezando?',
  a: 'Sí. Aunque fue diseñado pensando principalmente en profesionales activas, también puede ayudarte muchísimo si estás comenzando y querés construir estructura profesional desde el inicio. Incluso mejor que aprender improvisando durante años.'
}, {
  q: '¿Esto reemplaza capacitaciones técnicas?',
  a: 'NO. Este producto no fue diseñado para enseñarte técnica de peluquería. Fue diseñado para ayudarte a ordenar, profesionalizar y estructurar mejor cómo trabajás.'
}, {
  q: '¿Esto sirve si hago color, cortes, tratamientos o servicios variados?',
  a: 'Sí. Porque el sistema no depende de una técnica específica. Trabaja sobre: organización, consultas, clientas, cobros, protocolos y experiencia.'
}, {
  q: '¿Está pensado para Argentina?',
  a: 'Sí. Todo el lenguaje, enfoque y estructura fue adaptado pensando en el mercado argentino y perfectamente aplicable en Latinoamérica.'
}, {
  q: '¿Es solo para peluquerías grandes?',
  a: 'No. Sirve perfectamente si trabajás sola, tenés home studio, alquilás espacio, tenés un equipo chico o manejás un salón más estructurado. Porque el foco es mejorar tu sistema de trabajo.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibís acceso inmediato al material en formato digital descargable. No enviamos producto físico.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Una vez confirmado el pago: recibís acceso inmediato. Podés descargar y revisar el contenido el mismo día.'
}, {
  q: '¿Qué medios de pago aceptan?',
  a: 'Podés pagar con: MercadoPago, tarjeta de crédito, tarjeta de débito y medios habilitados según plataforma.'
}, {
  q: '¿Puedo imprimir las plantillas?',
  a: 'Sí. Muchos materiales fueron pensados justamente para que puedas imprimirlos y utilizarlos en tu operación diaria.'
}, {
  q: '¿Cuánto tiempo me lleva implementarlo?',
  a: 'Depende de tu ritmo. Pero muchas herramientas son de aplicación rápida e inmediata. No necesitás esperar semanas para empezar a ordenar cosas concretas.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-grayLight py-8 px-5" data-id="element-91">
      <div className="max-w-xl mx-auto" data-id="element-92">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-12" data-id="element-93">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-94">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white border border-slate-100 rounded-2xl overflow-hidden transition-all shadow-sm" data-id="element-95">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-slate-50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-96">
                <span className="font-bold text-slate-800 text-base pr-6" data-id="element-97">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-primary flex-shrink-0" size={20} data-id="element-98" /> : <ChevronDown className="text-slate-300 flex-shrink-0" size={20} data-id="element-99" />}
              </button>
              {openIdx === idx && <div className="px-6 pb-6 text-sm md:text-base text-slate-500 leading-relaxed border-t border-slate-50" data-id="element-100">
                  <div className="pt-5" data-id="element-101">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}